import {
  CMP_ID,
  CMP_VERSION,
} from 'constants/cmp'

const API_VERSION = '2'
const CMP_STATUS_ERROR = 'error'
const DISPLAY_STATUS_DISABLED = 'disabled'
const PING = 'ping'
const TCF_API_VERSION = 2


// Left alone, the backend's stub keeps answering `ping` with
// `cmpStatus: 'stub'`, which the TCF spec defines as "CMP not yet loaded", so
// every vendor waits for a CMP that is never coming. The spec says a CMP that
// cannot operate should report `cmpStatus: 'error'` and "shall not respond to
// any other API requests", which is what this does.
//
// https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20CMP%20API%20v2.md
//
// The stub's own message listener resolves `window.__tcfapi` at call time, so
// replacing the global keeps the postMessage path working through this.
//
export default function installErrorCmpApi() {
  const gdprApplies = readGdprApplies()

  window.__tcfapi = (command, version, callback) => {
    if ( command !== PING ) {
      return
    }

    if ( typeof callback !== 'function' ) {
      return
    }

    callback({
      apiVersion: API_VERSION,
      cmpId: CMP_ID,
      cmpLoaded: false,
      cmpStatus: CMP_STATUS_ERROR,
      cmpVersion: CMP_VERSION,
      displayStatus: DISPLAY_STATUS_DISABLED,
      gdprApplies,
    }, true)
  }
}

// The stub holds whatever `setGdprApplies` told it in a closure, and `ping` is
// the only way to read it back out before we replace the stub. Dropping it
// would swap one wrong answer for another.
//
function readGdprApplies() {
  const stub = window.__tcfapi

  if ( typeof stub !== 'function' ) {
    return void 0
  }

  const captured = {}

  stub(PING, TCF_API_VERSION, (pingReturn) => {
    captured.gdprApplies = pingReturn?.gdprApplies
  })

  return captured.gdprApplies
}
